import { useLocale } from "@hermes/intl";
import { useAuth } from "@hermes/shared";
import { type ReactNode, useEffect } from "react";
import { Helmet } from "react-helmet-async";

import { useAppConfig } from "../config/context";
import { gtagId } from "./gtag";

declare global {
  interface Window {
    [index: string]: any;
    isRobot?: boolean;
    isPrerender?: boolean;
  }
}

export const TagsWrapper = ({ children }: { children: ReactNode }) => {
  const [locale] = useLocale();
  const { user } = useAuth();
  const { isPrerender } = useAppConfig();

  useEffect(() => {
    window.gtag?.("set", "language", locale.baseName);
  }, [locale.baseName]);

  const enableDebug = import.meta.env.DOQ_ENVIRONMENT === "development";

  const config = JSON.stringify({
    send_page_view: false,
    cookie_domain: "auto",
    ...(enableDebug && {
      debug_mode: true,
    }),
  });
  return (
    <>
      {!isPrerender && !user && (
        <Helmet>
          {Boolean(import.meta.env.DOQ_GOOGLE_TAG_ID) && (
            <script>{`gtag('config', '${gtagId}', ${config}); window._gtagInitialized = true;`}</script>
          )}
          {Boolean(import.meta.env.DOQ_YANDEX_METRIKA_KEY) && (
            <script>
              {`ym(${import.meta.env.DOQ_YANDEX_METRIKA_KEY}, "init", {
                  clickmap:true,
                  trackLinks:true,
                  accurateTrackBounce:true,
                  webvisor:true,
                  ecommerce:"dataLayer"
                });window._ymInitialized = true;`}
            </script>
          )}
        </Helmet>
      )}
      {children}
    </>
  );
};

export { useCookiebot } from "./cookiebot";
export { parseGoogleSessionData, useGtag } from "./gtag";
export { useVWO, VWOProvider } from "./testing";
export { parseYandexSessionData, useYm } from "./ym";
